import React from 'react';
export function ForYouSection() {
  const isForYou = ['Sientes que hay un límite que llevas tiempo queriendo romper', 'Quieres una experiencia real, no más información o teoría', 'Buscas un espacio en español, con tu comunidad, donde te entiendan', 'Estás listo/a para demostrarle a tu mente que sí puedes', 'Quieres empezar un proceso de transformación real con respaldo profesional', 'Eres mujer lista para dar su siguiente paso o alguien que quiere regalarle esta experiencia a una mujer especial'];
  const notForYou = ['Buscas solo entretenimiento o pasar el rato', 'No estás dispuesto/a a participar activamente', 'Crees que ya lo sabes todo y no hay nada nuevo que puedas aprender de ti mismo/a'];
  return <section className="py-24 px-4 bg-[#1a0a2e] text-white" data-id="element-74">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-75">
        {/* Is For You */}
        <div className="bg-white/5 border border-green-500/30 p-8 md:p-10 rounded-3xl backdrop-blur-sm" data-id="element-76">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white" data-id="element-77">
            Esta noche es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-78">
            {isForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-79">
                <span className="text-green-400 text-xl shrink-0 mt-1" data-id="element-80">✅</span>
                <span className="text-gray-300 text-lg" data-id="element-81">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-white/5 border border-red-500/30 p-8 md:p-10 rounded-3xl backdrop-blur-sm" data-id="element-82">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white" data-id="element-83">
            Esta noche NO es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-84">
            {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-85">
                <span className="text-red-400 text-xl shrink-0 mt-1" data-id="element-86">❌</span>
                <span className="text-gray-300 text-lg" data-id="element-87">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}